import React from 'react'
import { useFormContext } from 'react-hook-form'

import { GroupInput } from '@/components/uikit'
import { pluralize } from '@/lib/helpers'

import type { LengthOfStayProps } from './types'

export const LengthOfStay: React.FC<LengthOfStayProps> = ({
  error,
  onChangeLengthOfStay,
  daysFormKey = 'lengthOfStayDays',
  nightsFormKey = 'lengthOfStayNights',
  isDisabled,
}) => {
  const { getValues, register, setValue } = useFormContext()
  return (
    <GroupInput label="Length of Stay" error={error} readOnly={isDisabled}>
      <GroupInput.GroupTextInput
        {...register(daysFormKey, {
          onChange: (e) => {
            const nDays = parseInt(e.currentTarget.value, 10)
            if (nDays <= 0) {
              setValue(daysFormKey, null)
              setValue(nightsFormKey, null)
            } else {
              setValue(nightsFormKey, nDays - 1)
            }
            onChangeLengthOfStay()
          },
          valueAsNumber: true,
          min: 1,
        })}
        inputWidth="50px"
        type="number"
        min="1"
        postfix={pluralize(getValues(daysFormKey) || '', 'Day')}
        disabled={isDisabled}
        readOnly={isDisabled}
      />
      <GroupInput.GroupTextInput
        {...register(nightsFormKey, {
          onChange: (e) => {
            const nNights = parseInt(e.currentTarget.value || 0, 10)
            setValue(daysFormKey, nNights + 1)
            onChangeLengthOfStay()
          },
          valueAsNumber: true,
          min: 0,
        })}
        inputWidth="50px"
        type="number"
        min="0"
        postfix={pluralize(getValues(nightsFormKey) || '', 'Night')}
        disabled={isDisabled}
        readOnly={isDisabled}
      />
    </GroupInput>
  )
}
